// extracted by mini-css-extract-plugin
export default {"format-example":"CasinoSettings_format-example__4Ygbo","formatExample":"CasinoSettings_format-example__4Ygbo"};